// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__32DCf","filesListContainer":"PosDisputesFiles_filesListContainer__1VVfb","filesButton":"PosDisputesFiles_filesButton__31_x-"};